import { Button } from './button';
import { Form } from './form';
import { Link } from './link';

export const data = {
  button: Button,
  link: Link,
  form: Form
};
